// Utils
import { getLocalizedString } from "../../utils/getLocalizedString";
import { theme } from "../../utils/theme";

// Icons
import { BsX } from "react-icons/bs";

const statusData = [
  {
    statusKey: "STATUS_DRAFT",
    descriptionKey: "ORDER_STATUS_DRAFT_LEGEND",
    color: theme.draftColor,
  },
  {
    statusKey: "STATUS_SUBMITTED",
    descriptionKey: "ORDER_STATUS_SUBMITTED_LEGEND",
    color: theme.waitingColor,
  },
  {
    statusKey: "STATUS_CONFIRMED",
    descriptionKey: "ORDER_STATUS_CONFIRMED_LEGEND",
    color: theme.confirmedColor,
  },
  {
    statusKey: "STATUS_CANCELLED",
    descriptionKey: "ORDER_STATUS_CANCELLED_LEGEND",
    color: theme.cancelledColor,
  },
];

const StatusItem = ({ status, isMobile, isLast }) => {
  const itemStyle = {
    marginBottom: isLast ? "0" : isMobile ? "16px" : "14px",
    padding: isMobile ? "12px" : "8px",
    backgroundColor: "#f8f9fa",
    borderRadius: "4px",
    borderLeft: `${isMobile ? "4px" : "3px"} solid ${status.color}`,
  };

  const titleStyle = {
    fontWeight: "bold",
    marginBottom: isMobile ? "8px" : "6px",
    color: status.color,
    textTransform: "uppercase",
    fontSize: isMobile ? "15px" : "13px",
  };

  const descriptionStyle = {
    color: "#555",
    fontSize: isMobile ? "14px" : "12px",
  };

  return (
    <div style={itemStyle}>
      <div style={titleStyle}>{getLocalizedString(status.statusKey)}</div>
      <div style={descriptionStyle}>
        {getLocalizedString(status.descriptionKey)}
      </div>
    </div>
  );
};

const StatusList = ({ isMobile }) => {
  return (
    <>
      {statusData.map((status, index) => (
        <StatusItem
          key={status.statusKey}
          status={status}
          isMobile={isMobile}
          isLast={index === statusData.length - 1}
        />
      ))}
    </>
  );
};

const OrderStatusLegend = ({
  mobile = false,
  onClose = null,
  backgroundColor = "rgba(0,0,0,0.9)",
}) => {
  // Mobile modal version
  if (mobile) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor,
          zIndex: 9999,
          display: "flex",
          alignItems: "start",
          justifyContent: "center",
          touchAction: "none",
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget && onClose) {
            onClose();
          }
        }}
      >
        <div style={{ padding: "0 10px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px 0px 10px 0px",
              borderBottom: "2px dotted #e5e5e5",
              marginBottom: "30px",
              color: "#fff",
            }}
          >
            <h2
              style={{
                fontSize: "20px",
              }}
            >
              {getLocalizedString("ORDER_STATUS_LEGEND_TITLE")}
            </h2>
            {onClose && (
              <BsX
                onClick={onClose}
                size={32}
                style={{
                  cursor: "pointer",
                }}
              />
            )}
          </div>
          <StatusList isMobile={true} />
        </div>
      </div>
    );
  }

  // Desktop tooltip version
  return (
    <div
      style={{
        minWidth: "300px",
        maxWidth: "380px",
        backgroundColor: "#fff",
        color: "#333",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        padding: "16px",
        fontSize: "13px",
      }}
    >
      <div
        style={{
          fontWeight: "bold",
          marginBottom: "14px",
          textAlign: "center",
          fontSize: "14px",
          color: "#222",
          borderBottom: "2px solid #e5e5e5",
          paddingBottom: "10px",
        }}
      >
        {getLocalizedString("ORDER_STATUS_LEGEND_TITLE")}
      </div>
      <StatusList isMobile={false} />
    </div>
  );
};

export default OrderStatusLegend;
